// store.js
import {combineReducers, createStore} from 'redux';
import {persistReducer, persistStore} from 'redux-persist';
import storage from 'redux-persist/lib/storage'; // uses localStorage for web

// Initial state for validation
const initialValidationState = {
    payload: null,
};

// A simple reducer for storing validation results
function validationReducer(state = initialValidationState, action) {
    switch (action.type) {
        case 'SET_VALIDATION_RESULT':
            return {...state, payload: action.payload};
        default:
            return state;
    }
}

const rootReducer = combineReducers({
    validation: validationReducer,
});

const persistConfig = {
    key: 'root',
    storage,
};

const persistedReducer = persistReducer(persistConfig, rootReducer);

export const store = createStore(persistedReducer);
export const persistor = persistStore(store);
